module.exports = __webpack_public_path__ + "static/img/3343_phase_function_Paper_Points.f264d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3343_phase_function_Paper_Points.png
// module id = quws
// module chunks = 0